import { z } from 'zod';
import * as PIXI from 'pixi.js';
import { CircuitType, Side } from '@/schemas/common';
import { TileSideIOType } from '@/schemas/tiles';
import { InputType } from '@/models/tiles/TileDefinition';
import { Signal } from '@/models/data/Signal';
import { Rotation } from '@/models/data/Rotation';
import { Point } from '@/models/Point';
import { standardBuildAndConnect } from '@/models/logic/utils';
import {
  defaultTileGraphics,
  connectionGraphics,
  sideGraphics,
} from '@/models/tiles/DefaultTileGraphics';
import { colors } from '@/styles';
import { configureTile } from '../configuration';
import { watchActiveExtensionNodes } from '../activeNodes';
import { watchExtensionOutputs } from '../outputs';
import { clockedBuild, clockNode, clockIo, watchClocks } from '../clocked';
import type { DigitilesExtension } from '../catalog';
import type { PackageManifest } from './manifest';

/** Versioned host imports: packages need not bundle a second renderer/schema library. */
export const extensionSDK = Object.freeze({
  apiVersion: 1 as const,
  z,
  PIXI,
  CircuitType,
  Side,
  TileSideIOType,
  InputType,
  Signal,
  Rotation,
  Point,
  colors,
  standardBuildAndConnect,
  defaultTileGraphics,
  connectionGraphics,
  sideGraphics,
  configureTile,
  watchActiveExtensionNodes,
  watchExtensionOutputs,
  clockedBuild,
  clockNode,
  clockIo,
  watchClocks,
});
export type ExtensionSDK = typeof extensionSDK;
export type ExtensionContributions = Pick<
  DigitilesExtension,
  'tiles' | 'nodes' | 'chips' | 'activate'
>;
export type ExtensionFactory = (
  sdk: ExtensionSDK,
  manifest: Readonly<PackageManifest>,
) => ExtensionContributions | Promise<ExtensionContributions>;
